module.exports = __webpack_public_path__ + "static/media/eye-icon.fee3cfc7.svg";